// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductView_container_3InY3","title":"ProductView_title_3WcaH"};